import { FC } from 'react'
import { InfiniteScrollCarousel } from '@/molecules/InfiniteScrollCarousel/InfiniteScrollCarousel'
import { useTranslate } from '@/utils/translate/translate-client'
import { GEyebrowLG } from '@/views/PreSales/PreSalesGiveawayView/components/Typography'
import { PartnerLogo } from '@/views/PreSales/PreSalesGiveawayView/hooks/useGiveawayConfigData'

interface Props {
  partnerLogos: PartnerLogo[]
}

export const PartnerLogosSection: FC<Props> = ({ partnerLogos }) => {
  const { t } = useTranslate('tickets')

  return (
    <div className="grid gap-4 py-8 pb-[96px] md:pt-[60px]">
      <GEyebrowLG className="block text-center" color="giveaway-text-subtle-light">
        {t('premiumPartners', 'INCLUDING PRODUCTS FROM OUR PREMIUM PARTNERS')}
      </GEyebrowLG>
      <InfiniteScrollCarousel images={partnerLogos} />
    </div>
  )
}
